import { createSlice } from "@reduxjs/toolkit";
import {
  getACLMenusActions,
  getAlerts,
  getFBCPaymentStatus,
  getGlobalSettings,
  getSettings,
  updateSettings,
  saveImportData,
  getLoanSettings,
  updateLoanSettings,
} from "./actions/menuActions";
const initialState = {
  vendorUserId: null,
  menus: null,
  actions: null,
  user: null,
  alerts: null,
  alertsLoading: false,
  deleteLoading: false,
  settings: null,
  loanSettings: null,
  globalSettings: null,
  settingsLoading: false,
  loanSettingsLoading: false,
  exportLoading: false,
  fbcPayStatus: null,
  fbcPayStatusLoading: false,
};
const extractActions = (actions) => {
  let tempAction = {};
  actions.forEach((action) => {
    let key = action.name.split(".")[0];
    let value = action.name.split(".")[1];
    if (tempAction[key]) {
      tempAction[key].push(value);
    } else {
      tempAction[key] = [value];
    }
  });
  return tempAction;
};
export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setDeleteLoading: (state, action) => {
      state.deleteLoading = action.payload;
    },
    emptyAlerts: (state) => {
      state.alerts = null;
    },
    setExportLoading: (state, action) => {
      state.exportLoading = action.payload;
    },
    resetFBCPayStatus: (state) => {
      state.fbcPayStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getACLMenusActions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getACLMenusActions.fulfilled, (state, action) => {
        state.loading = false;

        // const _newMenus = action.payload.menus;
        // _newMenus.forEach((menu) => {
        //   if (menu.name === "service") {
        //     menu.subMenu.push({
        //       id: 101,
        //       name: "fbcPaymentStatus",
        //       label: "FBC Payment Status",
        //       path: "/service/fbcPaymentStatus",
        //       masterId: 3,
        //     });
        //   }
        // });
        // state.menus = _newMenus;

        state.menus = action.payload.menus;
        state.actions = extractActions(action.payload.actions);
        state.user = action.payload.user;
        state.vendorUserId = action.payload.vendorUserId;
      })
      .addCase(getACLMenusActions.rejected, (state) => {
        window.location.href = "/login";
      });
    builder
      .addCase(getAlerts.pending, (state) => {
        state.alertsLoading = true;
      })
      .addCase(getAlerts.fulfilled, (state, action) => {
        state.alertsLoading = false;
        state.alerts = action.payload.data;
      })
      .addCase(getAlerts.rejected, (state) => {
        state.alertsLoading = false;
      });
    builder
      .addCase(getSettings.pending, (state) => {
        state.settingsLoading = true;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = action.payload.dataMap;
      })
      .addCase(getSettings.rejected, (state) => {
        state.settingsLoading = false;
      });
    builder.addCase(getGlobalSettings.fulfilled, (state, action) => {
      sessionStorage.setItem("dateFormat", action.payload.dateFormat);
      state.globalSettings = action.payload;
    });
    builder
      .addCase(updateSettings.pending, (state) => {
        state.settingsLoading = true;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = action.payload.dataMap;
      })
      .addCase(updateSettings.rejected, (state) => {
        state.settingsLoading = false;
      });
    builder
      .addCase(saveImportData.pending, (state) => {
        state.importData = true;
      })
      .addCase(saveImportData.fulfilled, (state, action) => {
        state.importData = false;
        state.import = action.payload.data;
      })
      .addCase(saveImportData.rejected, (state) => {
        state.importData = false;
      });
    builder
      .addCase(getFBCPaymentStatus.pending, (state) => {
        state.fbcPayStatusLoading = true;
      })
      .addCase(getFBCPaymentStatus.fulfilled, (state, action) => {
        state.fbcPayStatusLoading = false;
        state.fbcPayStatus = action.payload;
      })
      .addCase(getFBCPaymentStatus.rejected, (state) => {
        state.fbcPayStatusLoading = false;
      });
    builder
      .addCase(getLoanSettings.pending, (state) => {
        state.loanSettingsLoading = true;
      })
      .addCase(getLoanSettings.fulfilled, (state, action) => {
        state.loanSettingsLoading = false;
        state.loanSettings = action.payload;
      })
      .addCase(getLoanSettings.rejected, (state) => {
        state.loanSettingsLoading = false;
      });
    builder
      .addCase(updateLoanSettings.pending, (state) => {
        state.loanSettingsLoading = true;
      })
      .addCase(updateLoanSettings.fulfilled, (state, action) => {
        state.loanSettingsLoading = false;
        state.loanSettings = action.payload;
      })
      .addCase(updateLoanSettings.rejected, (state) => {
        state.loanSettingsLoading = false;
      });
  },
});
export const {
  setDeleteLoading,
  emptyAlerts,
  setExportLoading,
  resetFBCPayStatus,
} = menuSlice.actions;
export default menuSlice.reducer;
